const Experience = () => {
    return (
        <section id="experience">
            <h2>Experience</h2>
            <div className="experience-item">
                <h3>DevOps Engineer</h3>
                <p>Capgemini | August, 2022 - Present</p>
                <p>Responsible for automating deployment processes, managing cloud infrastructure, and ensuring high availability of applications.</p>
            </div>
            <div className="experience-item">
                <h3>Full Stack Engineer</h3>
                <p>Awishcar.com  | May, 2022 - July, 2022</p>
                <p>Managed PHP and JavaScript projects, implemented responsive UIs, and collaborated with cross-functional teams.</p>
            </div>
        </section>
    )
}

export default Experience;